export default {
  care: {
    hero: {
      eyebrow: 'SSG Care',
      title: 'Kako bi vaša tehnika kamera dugoročno pouzdano radila',
      lead: 'SSG Care naša je pretplata za održavanje i skrb. Nakon ugradnje možete svoj sustav trajno održavati fleksibilnim Care ugovorom – uz mjesečnu naknadu i individualno dogovoreno trajanje.',
    },
    abo: {
      title: 'Model pretplate s fleksibilnim trajanjem',
      lead: 'Ugradnja se obračunava jednokratno. Trajna skrb ide putem mjesečne pretplate – otkazive ili s fiksno dogovorenim minimalnim trajanjem.',
      items: {
        '0': { title: 'Mjesečna skrb', desc: 'Birajte između mjesečnog otkazivanja ili fiksnog trajanja (npr. 12 ili 24 mjeseca) s odgovarajućim uvjetima.' },
        '1': { title: 'Individualni opseg usluga', desc: 'Ne treba svaki sustav sve. Zajedno definiramo koje usluge pripadaju vašem Care ugovoru – skalabilno i prilagodljivo.' },
        '2': { title: 'Bez skrivenih troškova', desc: 'Transparentna mjesečna naknada. Dodatne usluge izvan ugovora dogovaraju se unaprijed i zasebno naplaćuju.' },
      },
    },
    pricing: {
      eyebrow: 'Tarife',
      title: 'Odaberite svoju Care tarifu',
      lead: 'Sve su cijene okvirne. Konačna mjesečna naknada ovisi o veličini sustava, željenom opsegu i trajanju.',
      featured: 'Najpopularniji izbor',
      plans: {
        '0': { name: 'Care Basic', subtitle: 'Za male sustave', price: 'od 19 €/mjesečno', features: { '0': 'Tromjesečna provjera (daljinski)', '1': 'Upravljanje ažuriranjima firmvera', '2': 'Podrška za aplikaciju telefonom/e-poštom', '3': 'Prioritetni zahtjevi' } },
        '1': { name: 'Care Professional', subtitle: 'Za poslovne sustave', price: 'od 39 €/mjesečno', features: { '0': 'Mjesečna provjera (daljinski)', '1': 'Ažuriranja firmvera i sigurnosne zakrpe', '2': 'Upravljanje korisnicima i pravima', '3': 'Kontrola pohrane i snimanja', '4': 'Pomoć pri promjeni pametnog telefona', '5': 'Servis na licu mjesta po dogovoru', '6': 'Prioritetna obrada' } },
        '2': { name: 'Care Enterprise', subtitle: 'Za više lokacija i velike projekte', price: 'Individualno', features: { '0': 'Tjedna provjera (daljinski)', '1': 'Sve usluge Professional', '2': 'Namjenski kontakt', '3': 'Proaktivni savjeti za proširenje', '4': 'Redoviti termini na licu mjesta', '5': 'Dokumentacija i izvještaji' } },
      },
    },
    services: {
      title: 'Što SSG Care može učiniti za vas',
      items: {
        '0': { title: 'Redovite provjere', desc: 'Kontrola funkcije kamere, snimanja i mrežne veze – daljinski ili na licu mjesta ovisno o paketu.' },
        '1': { title: 'Ažuriranja firmvera', desc: 'Provjera i provedba dogovorenih ažuriranja prema proizvođaču.' },
        '2': { title: 'Podrška za aplikaciju i pristup', desc: 'Pomoć kod problema s aplikacijom, pristupom i promjenom telefona.' },
        '3': { title: 'Upravljanje korisnicima i pravima', desc: 'Upravljanje pravima pristupa, novim korisnicima i promjenama ovlasti.' },
        '4': { title: 'Snimanje i pohrana', desc: 'Provjera zauzeća, kvalitete snimanja i sigurnosnih kopija.' },
        '5': { title: 'Daljinska podrška', desc: 'Daljinski pristup za dijagnostiku i konfiguraciju, ako je moguće i poželjno.' },
      },
    },
    form: {
      title: 'Vaša osobna Care ponuda',
      lead: 'Recite nam kakvu skrb zamišljate. Javit ćemo vam se s individualnim prijedlogom s trajanjem i mjesečnom naknadom.',
      customerType: 'Vrsta korisnika',
      select: 'Molimo odaberite',
      privat: 'Privatno',
      gewerbe: 'Poslovno',
      locations: 'Broj lokacija',
      locations1: '1 lokacija',
      locations2: '2–3 lokacije',
      locations3: '4 i više',
      cameraCount: 'Približan broj kamera',
      cameras1: '1–2 kamere',
      cameras2: '3–6 kamera',
      cameras3: '7–12 kamera',
      cameras4: '13 i više',
      systemStatus: 'Status sustava',
      statusNew: 'Novi sustav',
      statusExisting: 'Postojeći sustav',
      statusExtension: 'Planirano proširenje',
      contractTerm: 'Željeno trajanje ugovora',
      termOpen: 'Otvoreno / po dogovoru',
      termMonthly: 'Mjesečno otkazivo',
      term12: '12 mjeseci',
      term24: '24 mjeseca',
      term36: '36 mjeseci',
      name: 'Ime *',
      email: 'E-pošta *',
      phone: 'Telefon',
      company: 'Tvrtka',
      message: 'Dodatne informacije',
      maxChars: 'Najviše 500 znakova',
      consent: 'Pročitao/la sam politiku privatnosti i pristajem na obradu svojih podataka za ovaj zahtjev. *',
      success: 'Hvala na vašem zahtjevu. Javit ćemo vam se uskoro s vašom individualnom Care ponudom.',
      submit: 'Pošalji Care zahtjev',
      submitting: 'Slanje...',
    },
  },
};